const experiences = [
    {
      title: "Technical operator",
      company_name: "Nokia network solutions",
      iconBg: "#E6DEDD",
      date: "June 2015 – April 2015",
      points: [
        "Highlight your ability to identify and resolve technical issues, conduct routine maintenance tasks, and perform repairs to ensure the smooth operation of equipment and systems.",
        "Highlight your experience in conducting quality checks, inspecting products or services for adherence to specifications, and implementing corrective actions to maintain high-quality standards.",
        "Highlight your ability to identify and resolve technical issues, conduct routine maintenance tasks, and perform repairs to ensure the smooth operation of equipment and systems.",
      ],
    },
    {
      title: "Customer Care Executive",
      company_name: "Teleperformance Pvt.ltd",
      iconBg: "#383E56",
      date: "June 2018 – July 2019",
      points: [
        "Provide exceptional customer service by addressing customer inquiries, resolving complaints, and handling escalations in a timely and professional manner.",
        "Handle customer complaints and conflicts with empathy, patience, and professionalism, and work towards finding a satisfactory resolution.",
        "Identify and resolve customer issues using critical thinking and problem-solving skills to ensure customer satisfaction and retention.",
      ],
    },
    {
      title: "Senior Representative Operations",
      company_name: "Concentrix",
      iconBg: "#E6DEDD",
      date: "February 2020 – April 2023",
      points: [
        "Monitored online forums and social media channels for inappropriate content and promptly removed offending posts.",
        "Responded to user inquiries and complaints, providing prompt and professional customer support.",
        "Analyzed user behavior and engagement metrics to identify trends and improve content strategy.",
        "Collaborated with cross-functional teams to develop content guidelines and policies, ensuring all content met established standards.",
      ],
    },
  ];

export{experiences};